// External-Dependencies
import { isUndefined, pickBy } from 'lodash';

// WP-Dependencies
import { Component } from '@wordpress/element';
import { PanelBody, QueryControls } from '@wordpress/components';
import apiFetch from '@wordpress/api-fetch';
import { addQueryArgs } from '@wordpress/url';
// import { __ } from '@wordpress/i18n';
// import { dateI18n, format, __experimentalGetSettings } from '@wordpress/date';
import { InspectorControls } from '@wordpress/block-editor';
import { withSelect } from '@wordpress/data';
import { decodeEntities } from '@wordpress/html-entities';

//Constants
import {
	MIN_EXCERPT_LENGTH,
	MAX_EXCERPT_LENGTH,
	MAX_POSTS_COLUMNS,
} from './constants';


export default withSelect( ( select, props ) => {
	

	const {
		fb_url,
		tw_url,
		ig_url,
		in_url,
	} = props.attributes;
	
//	 console.log("1-Edit");
//	  console.log(props);


	return { 
		url: select('core/editor').getPermalink(),
		title: select('core/editor').getEditedPostAttribute( 'title' ),
		summary: select('core/editor').getEditedPostAttribute( 'excerpt' ),
	 };

})( function( props ) {
	
//	const {
//		attributes,
//		setAttributes,
//	} = props;
//	
//        console.log("From Edit");
//	console.log(props);
//
//	const {
//		fb_url,
//		tw_url,
//		ig_url,
//		in_url,
//	} = attributes;
        
        const {
		attributes: {
                    fb_url,
                    tw_url,
                    ig_url,
                    in_url,
                },
		setAttributes,
	} = props;
        
        
	const smBEditorStyleUl = {
	    display:"flex",
	    // float: "left",
	    listStyle: "none",
	    marginLeft: "0",
	    paddingLeft: "0",
	};

	const smBEditorStyleLi = {
		// float: "left",
		marginLeft: "10px",
		padding: "5px",
		backgroundColor: "#da1f3d",
		color: "#fff"
	};
	// console.log("2-Edit");
	// console.log(props);
	// console.log(props);

	// <a href="https://www.facebook.com/sharer/sharer.php?u=#url" target="_blank">Share</a>
	var fbString = "https://www.facebook.com/sharer/sharer.php?u="+props.url;
	var twString = "https://twitter.com/intent/tweet?text="+props.title+"&url="+props.url+"&hashtags=GTÜ";
	// https://www.linkedin.com/shareArticle?mini=true&url=http://developer.linkedin.com&title=LinkedIn%20Developer%20Network&summary=My%20favorite%20developer%20program&source=LinkedIn
	var inString = "https://www.linkedin.com/shareArticle?mini=true&url="+props.url+"&title="+props.title+"&summary="+props.summary+"&source=GTÜ";

	setAttributes({ 'fb_url': fbString });
	setAttributes({ 'tw_url': twString });
	setAttributes({ 'in_url': inString });

	//<li><a href="" target="_blank"><i class="ig_link"></i></a></li>
	return (
		<>
			<ul style={smBEditorStyleUl}>
				<li style={smBEditorStyleLi}>facebook</li>
				<li style={smBEditorStyleLi}>twitter</li>
				<li style={smBEditorStyleLi}>linkedin</li>
			</ul>
		</>
	);
});



